import { create } from 'zustand';
export const useGuestBooking = create((set) => ({
    basket: [],
    contact: null,
    confirmedBookingIds: [],
    addItem: (item) => set((s) => ({ basket: [...s.basket, item] })),
    removeItem: (index) => set((s) => ({ basket: s.basket.filter((_, i) => i !== index) })),
    setContact: (c) => set({ contact: c }),
    setConfirmedIds: (ids) => set({ confirmedBookingIds: ids }),
    reset: () => set({ basket: [], contact: null, confirmedBookingIds: [] }),
}));
